export default {"src":"/_next/static/media/person_64.2254031d.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};